import React from 'react';

class PickingTable extends React.Component {
    
    getQuantityColor(quantity) {
        if (quantity <= 5) {
            return { bg: '#E7CC49BF', text: '#000000' };
        } else if (quantity <= 20) {
            return { bg: '#EF8C8CA6', text: '#000000' };
        } else if (quantity <= 50) {
            return { bg: '#E57373', text: '#FFFFFF' };
        } else if (quantity <= 80) {
            return { bg: '#EF5350', text: '#FFFFFF' };
        } else if (quantity <= 100) {
            return { bg: '#F44336', text: '#FFFFFF' };
        } else {
            return { bg: '#C62828', text: '#FFFFFF' };
        }
    }

    renderLoader() {
        return (
            <div className="picking-progress-loader">
                <div className="picking-progress-content">
                    <i className="fas fa-box-open picking-progress-icon"></i>
                    <h3 className="picking-progress-title">{this.props.loadingTitle || 'Loading Data'}</h3>
                    <p className="picking-progress-subtitle">
                        <span className="picking-progress-spinner"></span>
                        {this.props.loadingSubtitle || 'Fetching data...'}
                    </p>
                    <div className="picking-progress-bar-container">
                        <div className="picking-progress-bar"></div>
                    </div>
                    <p className="picking-progress-tips">
                        {this.props.loadingTip || 'This may take a few seconds'}
                    </p>
                </div>
            </div>
        );
    }

    renderCutoffError(errorMessage) {
        var timeMatch = errorMessage.match(/(\d{1,2}[.:]\d{2}\s*(?:AM|PM|am|pm)?)/);
        var cutoffTime = timeMatch ? timeMatch[1] : '15:00 PM';
        
        return (
            <div className="picking-cutoff-error">
                <div className="picking-cutoff-error-content">
                    <i className="fas fa-clock picking-cutoff-icon"></i>
                    <h3 className="picking-cutoff-title">Data Not Yet Available</h3>
                    <p className="picking-cutoff-message">
                        {errorMessage}
                    </p>
                    <div className="picking-cutoff-time">
                        <i className="fas fa-hourglass-half"></i> Available after {cutoffTime}
                    </div>
                    <p className="picking-cutoff-hint">
                        <i className="fas fa-info-circle"></i> {this.props.cutoffHint || 'Data is refreshed daily at the cutoff time'}
                    </p>
                </div>
            </div>
        );
    }

    renderError(errorMessage) {
        return (
            <div className="picking-empty-state">
                <i className="fas fa-exclamation-circle picking-empty-icon" style={{ color: '#f44336' }}></i>
                <h3 className="picking-empty-title">Error Loading Data</h3>
                <p className="picking-empty-subtitle">{errorMessage}</p>
            </div>
        );
    }

    renderEmptyState() {
        return (
            <div className="picking-empty-state">
                <i className="fas fa-inbox fa-3x picking-empty-icon"></i>
                <h3 className="picking-empty-title">{this.props.emptyTitle || 'No data available'}</h3>
                <p className="picking-empty-subtitle">{this.props.emptySubtitle || 'Try selecting a different date'}</p>
            </div>
        );
    }

    render() {
        const { 
            data, 
            isLoading, 
            error, 
            onRefresh,
            title = 'Pending Picks Information',
            displayLimit = 10,
            sortByKey = 'pendingQuantity',
            sortOrder = 'desc'
        } = this.props;

        if (isLoading) {
            return this.renderLoader();
        }

        if (error) {
            var isCutoffError = error.toLowerCase().includes('check after') || 
                               error.toLowerCase().includes('pm') ||
                               error.toLowerCase().includes('cutoff');
            
            if (isCutoffError) {
                return this.renderCutoffError(error);
            }
            
            return this.renderError(error);
        }

        if (!data || !data.length) {
            return this.renderEmptyState();
        }

        // Sort data
        const sortedData = data.slice().sort(function(a, b) {
            if (sortOrder === 'desc') {
                return b[sortByKey] - a[sortByKey];
            }
            return a[sortByKey] - b[sortByKey];
        });

        // Limit display
        const displayData = sortedData.slice(0, displayLimit);
        const hasMoreItems = sortedData.length > displayLimit;

        return (
            <div className="picking-table-container">
                <div className="picking-table-header">
                    <div>
                        <h3 className="picking-table-title">{title}</h3>
                        <span className="picking-table-subtitle">
                            {hasMoreItems ? (
                                <span>
                                    Showing top <strong>{displayLimit}</strong> of <strong>{data.length}</strong> products with highest quantity
                                </span>
                            ) : (
                                <span>{data.length} product(s) pending</span>
                            )}
                        </span>
                    </div>
                    {onRefresh && (
                        <button 
                            onClick={onRefresh}
                            className="picking-table-refresh-btn"
                        >
                            <i className="fas fa-sync-alt"></i> Refresh
                        </button>
                    )}
                </div>
                
                <div style={{ overflowX: 'auto' }}>
                    <table className="picking-table">
                        <thead className="picking-table-header-row">
                            <tr>
                                <th className="picking-table-header-cell" style={{ textAlign: 'left', width: '40vw'}}>Product Title</th>
                                <th className="picking-table-header-cell" style={{ textAlign: 'center', width: '10vw' }}>Pending Quantity</th>
                                <th className="picking-table-header-cell" style={{ textAlign: 'left', width: '25vw'}}>Space Names</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayData.map((item, index) => {
                                const quantityColor = this.getQuantityColor(item.pendingQuantity);
                                const isEvenRow = index % 2 === 0;
                                return (
                                    <tr 
                                        key={index} 
                                        className="picking-table-row"
                                        style={{ backgroundColor: isEvenRow ? '#fafafa' : '#ffffff' }}
                                    >
                                        <td 
                                            className={'picking-product-cell ' + (isEvenRow ? 'picking-product-cell-even' : 'picking-product-cell-odd')}
                                            style={{ 
                                                borderLeft: '4px solid ' + (quantityColor.bg || '#e0e0e0')
                                            }}
                                        >
                                            <div className="picking-product-content">
                                                <div className="picking-product-icon-badge">
                                                    <i className="fas fa-box picking-product-icon"></i>
                                                    <div className="picking-status-dot" style={{ background: quantityColor.bg }}></div>
                                                </div>
                                                <div className="picking-product-info">
                                                    <div className="picking-product-title">
                                                        {item.productTitle}
                                                    </div>
                                                    <div className="picking-product-id">
                                                        ID: {item.productId}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td 
                                            className="picking-quantity-cell"
                                            style={{ 
                                                backgroundColor: quantityColor.bg,
                                                color: quantityColor.text
                                            }}
                                        >
                                            {item.pendingQuantity}
                                        </td>
                                        <td 
                                            className={'picking-space-cell ' + (isEvenRow ? 'picking-space-cell-even' : 'picking-space-cell-odd')}
                                        >
                                            <div className="picking-space-badges">
                                                {item.spaceNames.map(function(spaceName, idx) {
                                                    return (
                                                        <span key={idx} className="picking-space-badge">
                                                            <i className="fas fa-map-marker-alt picking-space-icon"></i>
                                                            {spaceName}
                                                        </span>
                                                    );
                                                })}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default PickingTable;




// WEBPACK FOOTER //
// ./src/commons/PickingTable.js